import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#14505c] text-white py-12" data-id="element-46">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-47">
        <div className="text-center mb-6" data-id="element-48">
          <p className="text-sm mb-4" data-id="element-49">
            © 2026 KIT Psicología en Gerontes. Todos los derechos reservados.
          </p>
        </div>
        <div className="max-w-4xl mx-auto space-y-4 text-xs text-white/80 text-center md:text-left" data-id="element-50">
          <p data-id="element-51">
            Este material es una herramienta educativa y profesional para
            psicólogos y terapeutas. No reemplaza formación específica.
          </p>
          <p data-id="element-52">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </div>
    </footer>;
}